import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { services } from '../components/Home/Tiles/Services';
import { REQUEST_UNIVERSAL_SEARCH } from '../sagas/universalSearch';
import { URGENT_CARE_VALUE } from '~/components/Home/Tiles/ProviderTypes';

/**
 * Hook for initiating a service(s)-specific universal search
 *
 * @param service_index {number} references index in the services array
 * @returns {Function} callback function that updates the universal search to a service(s)-specific search
 */
// consider future investigation to remove the joining of the urgent care value (currently break downstream with out it).
export default (service_index: number) => {
  const dispatch = useDispatch();
  return useCallback(() => {
    const fullDoc = {
      type: 'service',
      provider_type: services[service_index].providerType,
      category: services[service_index].category,
      name: services[service_index].name,
      id: [services[service_index].ids, URGENT_CARE_VALUE].join('_'),
      highlight: services[service_index].highlight,
      is_covid_related: services[service_index].isCovidRelated,
      is_flu_related: services[service_index].isFluRelated,
    };

    dispatch({ type: REQUEST_UNIVERSAL_SEARCH, fullDoc });
  }, [dispatch, service_index]);
};
